import { API_MAX_LIMIT } from '../Common/constants';

/** Custom list endpoints that accept LoopBack `filter` and should auto-paginate. */
const PAGINATED_CUSTOM_PATHS = new Set(['AccountUsers/by-company-tree']);

export function isListModelPath(path) {
  if (!path || typeof path !== 'string') return false;

  if (PAGINATED_CUSTOM_PATHS.has(path)) return true;

  return path.indexOf('/') === -1 && path.indexOf('?') === -1;
}

export function shouldAutoPaginate(path, filter) {
  if (!isListModelPath(path)) return false;
  if (!filter || typeof filter !== 'object') return true;
  if (filter.limit === undefined || filter.limit === null) return true;

  const numericLimit = Number(filter.limit);
  return !isNaN(numericLimit) && numericLimit > API_MAX_LIMIT;
}

export function buildPagePlan(filter = {}, maxLimit = API_MAX_LIMIT) {
  const baseFilter = filter && typeof filter === 'object' ? { ...filter } : {};
  const requestedLimit =
    baseFilter.limit === undefined || baseFilter.limit === null ? null : Number(baseFilter.limit);
  const maxItems =
    requestedLimit !== null && !isNaN(requestedLimit) ? requestedLimit : Number.POSITIVE_INFINITY;

  return {
    baseFilter,
    maxItems,
    maxLimit,
    initialSkip: baseFilter.skip || 0
  };
}

export function nextPageFilter(baseFilter, skip, remaining, maxLimit = API_MAX_LIMIT) {
  const pageSize = Math.min(maxLimit, remaining);
  return {
    ...baseFilter,
    limit: pageSize,
    skip
  };
}
